import {
  SegmentedControl as MantineSegmentedControl,
  type SegmentedControlProps,
} from "@mantine/core";
import {
  type Control,
  type FieldValues,
  type Path,
  useController,
} from "react-hook-form";

interface Props<T extends FieldValues> extends SegmentedControlProps {
  name: Path<T>;
  control: Control<T>;
}

function SegmentedControl<T extends FieldValues>({
  name,
  control,
  ...props
}: Props<T>) {
  const { field } = useController({
    name,
    control,
  });

  return <MantineSegmentedControl {...props} {...field} />;
}

export default SegmentedControl;
